<template>
  <div class="Page">
    <HeaderSection 
      title="Colofon"
      :closeLinkTo="{ name: 'home'}">
      <p>
        Hi there!
      </p>
    </HeaderSection>

    <ContentSection>
    </ContentSection>
  </div>
</template>

<script>
import ContentSection from '@/components/section/ContentSection';
import HeaderSection from '@/components/section/HeaderSection';

export default {
  name: 'PageColofon',
  components: {
    HeaderSection,
    ContentSection
  }
}
</script>
